'use strict';

var React = require('react');

module.exports = function (props) {
    return React.createElement('svg', Object.assign({ viewBox: '0 0 1024 1024' }, props), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M768 0h-512c-35.2 0-64 28.8-64 64v896c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-896c0-35.2-28.8-64-64-64zM384 960h-128v-128h128v128zM384 768h-128v-128h128v128zM384 576h-128v-128h128v128zM576 960h-128v-128h128v128zM576 768h-128v-128h128v128zM576 576h-128v-128h128v128zM768 960h-128v-128h128v128zM768 768h-128v-128h128v128zM768 576h-128v-128h128v128zM768 384h-512v-320h512v320z' })
    ));
};